var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxPlots1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "18px",
    height: "18.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.470588 120.952471v783.058823h783.058824v60.235294H60.235294v-843.294117h60.235294z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M481.882353 181.187765v60.235294H361.411765v64.391529h120.470588v416.527059l-120.470588-0.060235v60.235294l120.470588 0.060235v60.235294H180.705882v-60.235294l120.470589-0.060235v-60.235294l-120.470589 0.060235V305.874824l120.470589-0.060236V241.423059H180.705882v-60.235294h301.176471z m-59.211294 181.669647H240.941176v301.17647l60.235295-0.060235v-0.903529h60.235294v0.903529h61.259294v-301.176471z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M835.102118 90.352941v60.235294h-120.470589v120.470589h120.470589v416.466823h-120.470589v120.470588h120.470589v60.235294h-301.176471v-60.235294h120.470588v-120.470588h-120.470588V271.058824h120.470588v-120.470589h-120.470588v-60.235294h301.176471z m-59.211294 237.688471H594.160941v301.17647h60.235294v-0.963764h60.235294v0.963764h61.259295v-301.17647z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxPlots1);
export default __webpack_public_path__ + "static/media/box_plots_1.e9fde120f4b8567b591fbb7f2c4c8e37.svg";
export { ForwardRef as ReactComponent };